export enum Author {
  CKE = 'cke',
  Operon = 'operon',
}
